module.exports = __webpack_public_path__ + "static/media/upload.bb2875a3.svg";